import React, { useEffect, useState } from "react";
import { Button, Table, Spinner } from "react-bootstrap";

const AsistenciaListModal = ({ cursoId, onClose, onEdit, onExcusa }) => {
  const [asistencias, setAsistencias] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAsistencias = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_API}api/asistencia/asistencias/?curso=${cursoId}`,
        );
        const data = await response.json();
        setAsistencias(data);
      } catch (error) {
        console.error("Error fetching asistencia:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAsistencias();
  }, [cursoId]);

  const formatFechaLocal = (isoDateStr) => {
    const [, month, day] = isoDateStr.split("-");
    const meses = [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ];
    return `${day}-${meses[parseInt(month, 10) - 1]}`;
  };

  return (
    <div>
      <h6>Listado de días</h6>
      {loading ? (
        <div className="d-flex justify-content-center p-5">
          <Spinner />
        </div>
      ) : asistencias.length === 0 ? (
        <p>No hay registros aún.</p>
      ) : (
        <Table striped bordered size="sm">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Asistentes</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {asistencias.map((asistencia) => (
              <tr key={asistencia.id}>
                <td>{formatFechaLocal(asistencia.fecha)}</td>
                <td>{asistencia.maestras_asistentes_nombre.length}</td>
                <td>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => onEdit(asistencia)}
                    style={{ fontSize: "10px" }}
                  >
                    Editar
                  </Button>
                  <Button
                    variant="outline-dark"
                    size="sm"
                    onClick={() => onExcusa(asistencia)}
                    style={{ fontSize: "10px", marginLeft: "5px" }}
                  >
                    Excusas
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
      <Button
        className="asistencia-curso-nuevo"
        onClick={() => {
          if (!loading) onClose(); // ✅ only allow if data loaded
        }}
        disabled={loading}
      >
        Nueva Asistencia
      </Button>
    </div>
  );
};

export default AsistenciaListModal;
